<template>
  <JBottomSheet v-model="internalModelValue" fullScreen>
    <template #header>
      <JContainer class="px-24 py-12">
        <h3 class="pb-8 text-center text-pane-header font-bold text-primary">
          {{ $t('words.book') }} {{ $t('search.nonCommercial') }}
          {{ $t('flight') }}
        </h3>
      </JContainer>
    </template>

    <div class="px-16">
      <AircraftTravelerInformationForm />
    </div>
  </JBottomSheet>
</template>

<script setup lang="ts">
import { JBottomSheet, JContainer } from '@journey/ui-kit'
import { useVModel } from '@vueuse/core'
import AircraftTravelerInformationForm from '../AircraftTravelerInformationForm/AircraftTravelerInformationForm.vue'
import type { Emits, Props } from './AircraftBookBottomSheet.types'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const internalModelValue = useVModel(props, 'modelValue', emit)
</script>
